import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const MULTI_KEYS = ["organization", "city", "state", "gender", "race", "event_group"];
export const FILTER_KEYS = ["start", "end", "age_min", "age_max", "q", "include_sample", "history", "entry_type", ...MULTI_KEYS];

export function paramsFrom(searchParams) {
  const p = new URLSearchParams();
  FILTER_KEYS.forEach((k) => {
    searchParams.getAll(k).forEach((v) => {
      if (v !== "") p.append(k, v);
    });
  });
  return p;
}
